/* eslint-disable no-nested-ternary */
import { Box, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

interface CompanyCardTitleProps {
    organisationName: string
    organisationId?: string
}

const CompanyCardTitle = ({
    organisationName,
    organisationId,
}: CompanyCardTitleProps): ReactElement => {
    const theme = useTheme()
    return (
        <Box
            sx={{
                display: "flex",
                verticalAlign: "center",
                gap: 2,
            }}
        >
            {organisationName}
            {organisationId ? (
                <Box>
                    <Typography
                        variant="caption"
                        display="contents"
                        color={theme.palette.text.secondary}
                    >
                        {" "}
                        ({organisationId})
                    </Typography>
                </Box>
            ) : null}
        </Box>
    )
}
CompanyCardTitle.defaultProps = {
    organisationId: null,
}

export default CompanyCardTitle
